import { http } from '../helpers/axiosHelper';
export default class TagService {
   async createTag(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tag', body).then((response) => {
         return response.data;
      });
   }

   async updateTag(tagId: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tag/' + tagId, body);
   }

   async deleteTag(tagId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tag/' + tagId);
   }
}
